import React from 'react';

export default function MemberStatsChip({ stats }) {
  if (!stats) return null;
  const { wins = 0, losses = 0, locksCompleted = 0, streak = 0 } = stats;
  const hasActivity = wins + losses + locksCompleted > 0;
  if (!hasActivity) return null;

  return (
    <div className="flex flex-wrap gap-1.5">
      <span className="inline-flex items-center rounded-full border border-gray-700/80 bg-gray-900/60 px-2 py-0.5 text-[10px] font-black uppercase tracking-wide text-gray-300">
        {wins}-{losses}
      </span>
      {locksCompleted > 0 && (
        <span className="inline-flex items-center rounded-full border border-violet-500/30 bg-violet-500/10 px-2 py-0.5 text-[10px] font-black uppercase tracking-wide text-violet-300">
          {locksCompleted} lock{locksCompleted === 1 ? '' : 's'}
        </span>
      )}
      {streak > 1 && (
        <span className="inline-flex items-center rounded-full border border-emerald-500/30 bg-emerald-500/10 px-2 py-0.5 text-[10px] font-black uppercase tracking-wide text-emerald-300">
          {streak}W streak
        </span>
      )}
    </div>
  );
}
